import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useI18n } from '../../i18n/I18nContext';
import SidebarFrame from '../Sidebar/SidebarFrame';
import { useTeacherNav } from '../Sidebar/shellNav';
import AppShell from './AppShell';

/**
 * Teacher workspace rail — the same floating glass chrome as the staff rail, with the teacher's
 * four destinations. Below 1024px it is the drawer the top pill's menu button opens
 * (`mobileOpen`), closed by `onMobileClose`. Signing out lives in the top bar's profile menu.
 */
function TeacherSidebar({ nav, mobileOpen = false, onMobileClose }) {
  const location = useLocation();
  const { user } = useAuth();
  const { t } = useI18n();
  const name = user?.name || user?.email?.split('@')[0] || t('layout.userFallback');

  useEffect(() => {
    onMobileClose?.();
    // Closing the drawer is tied to navigation only. The callback is omitted
    // from dependencies because the shell supplies a new inline function.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <SidebarFrame
      className="teacher-sidebar"
      ariaLabel={t('layout.teacherNav')}
      homeTo="/teacher/dashboard"
      tag={{ label: t('layout.teacherBadge'), tone: 'success' }}
      groups={nav.groups}
      user={{ name, sub: t('layout.teacherBadge'), avatar: user?.avatar, to: '/teacher/dashboard' }}
      mobileOpen={mobileOpen}
      onMobileClose={onMobileClose}
    />
  );
}

/** The teacher shell: same shell as the staff one, with the teacher rail and tab bar. */
function TeacherLayout({ children }) {
  const nav = useTeacherNav();
  return (
    <AppShell nav={nav} sidebar={(shell) => <TeacherSidebar nav={nav} {...shell} />}>
      {children}
    </AppShell>
  );
}

export default TeacherLayout;
